export default __webpack_public_path__ + "bec8039ee4fcaeb3d51c66702f9cac51.gif";